var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "o-grid c-toc" }, [
    _c(
      "div",
      {
        staticClass: "o-grid__column c-toc__link-wrapper",
        attrs: { "data-size": "sm:12 md:4 lg:4" }
      },
      [_vm._t("toc")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "scroll-spy",
            rawName: "v-scroll-spy",
            value: { offset: 0 },
            expression: "{ offset: 0 }"
          }
        ],
        staticClass: "o-grid__column c-toc__content-wrapper richtext",
        attrs: { "data-size": "sm:12 md:7 lg:7 offset:1" }
      },
      [_vm._t("content")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }